var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.713,
    viewBox: "0 0 16 15.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119",
    transform: "translate(-16.4 -17.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M31.837,79.2H16.963a.563.563,0,0,0,0,1.126H31.837a.563.563,0,1,0,0-1.126Z",
    transform: "translate(0 -47.588)",
    fill: "#e41e26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M16.423,26.685,16.4,29.336a.515.515,0,0,0,.164.4.666.666,0,0,0,.4.164l2.651-.023a.666.666,0,0,0,.4-.164l9.1-9.1a.581.581,0,0,0,0-.8l-2.628-2.628a.581.581,0,0,0-.8,0l-1.83,1.83-7.273,7.273A.549.549,0,0,0,16.423,26.685Zm11.5-6.475-1.032,1.032-1.83-1.83,1.032-1.032ZM17.55,26.92l6.71-6.71,1.83,1.83-6.71,6.71H17.55Z",
    transform: "translate(0)",
    fill: "#e41e26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8fc4226c530a12237d590448a3520c6d.svg";
export { ForwardRef as ReactComponent };